import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Reusable Refresh button for admin pages. Calls the passed-in async loader
 * and spins the icon while in-flight. Filters/pagination state lives in the
 * caller, so we never reset it here — we just trigger the same fetch the page
 * already runs on mount. */
export function AdminRefreshButton({ onRefresh, testId = "admin-refresh", className = "" }) {
  const [busy, setBusy] = useState(false);
  const click = async () => {
    if (busy) return;
    setBusy(true);
    try { await onRefresh(); }
    finally { setBusy(false); }
  };
  return (
    <Button
      variant="ghost"
      size="sm"
      type="button"
      onClick={click}
      disabled={busy}
      data-testid={testId}
      className={className}
      aria-label="Refresh"
    >
      <RefreshCw className={`mr-1.5 h-4 w-4 ${busy ? "animate-spin" : ""}`} />
      Refresh
    </Button>
  );
}
